import { api } from "@/core/api/";

export default {
    getRegionByAcademicYear(properties) {
        return api.get("api/anejo/region", {
            params: {
                ...properties
            }
        });
    },
    getCenters(properties) {
        return api.get("api/anejo/center", {
            params: {
                ...properties
            }
        });
    },
    getMunicipality(properties) {
        return api.get("api/anejo/municipality", {
            params: {
                ...properties
            }
        });
    },
    getSchool(properties) {
        return api.get("api/anejo/school", {
            params: {
                ...properties
            }
        });
    },
    getProvider(properties) {
        return api.get("api/anejo/provider", {
            params: {
                ...properties
            }
        });
    },
    getSpecialist(properties) {
        return api.get("api/anejo/specialist", {
            params: {
                ...properties
            }
        });
    },
}